export default class SepaCreditTransferExportAvailability {

    constructor() {
        this.isAvailable = false;
        this.messages = [];
        this.hasRunningExport = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let availability = new SepaCreditTransferExportAvailability();
        availability.isAvailable = data.isAvailable;
        availability.messages = data.messages;
        availability.messages = data.messages;
        availability.hasRunningExport = data.hasRunningExport;

        return availability;
    }

}
